import _ from 'underscore';
import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { DefaultButton, PrimaryButton } from '@bingads-webui-react/fabric-with-signal';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useIsReadOnlyUser } from '@bingads-webui-campaign-react/mca-core';

import { getStepProgressFooterStyles } from '../styles/step-progress-footer-styles';
import { StepProgressBar } from './step-progress-bar';

export function StepProgressFooter(props) {
  const {
    steps,
    previousButtonLabel,
    nextButtonLabel,
    onPreviousClick,
    onNextClick,
    onCancelClick,
    isNextButtonDisabled,
    disableButtons,
  } = props;
  const classes = useDefaultStyles(getStepProgressFooterStyles);
  const i18n = useContext(I18nContext);
  const isReadOnlyUser = useIsReadOnlyUser();

  return (
    <div className={classNames('step-progress-footer', classes.footerContainer)}>
      <div className={classNames('step-footer-left', classes.footerLeft)}>
        {
          _.isFunction(onPreviousClick) &&
          <DefaultButton
            className={classNames('step-previous-btn', classes.previousButton)}
            onClick={onPreviousClick}
            name="BackButtonOnStepProgressFooter"
            disabled={disableButtons}
          >
            {previousButtonLabel || i18n.getString(_TL_('Back'))}
          </DefaultButton>
        }
        {
          _.isFunction(onNextClick) &&
          <PrimaryButton
            className={classNames('step-next-btn')}
            onClick={onNextClick}
            disabled={disableButtons || isReadOnlyUser || isNextButtonDisabled}
            name="NextButtonOnStepProgressFooter"
          >
            {nextButtonLabel || i18n.getString(_TL_('Next'))}
          </PrimaryButton>
        }
      </div>

      <div className={classNames('step-footer-middle', classes.footerMiddle)}>
        {
          !_.isEmpty(steps) &&
          <StepProgressBar steps={steps} />
        }
      </div>

      <div className={classNames('step-footer-right', classes.footerRight)}>
        {
          _.isFunction(onCancelClick) &&
          <DefaultButton
            className={classNames('step-cancel-btn', classes.cancelButton)}
            onClick={onCancelClick}
            name="CancelButtonOnStepProgressFooter"
            disabled={disableButtons}
          >
            {i18n.getString(_TL_('Cancel'))}
          </DefaultButton>
        }
      </div>
    </div>
  );
}

StepProgressFooter.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    isCurrentStep: PropTypes.bool,
  })),
  previousButtonLabel: PropTypes.string,
  nextButtonLabel: PropTypes.string,
  onPreviousClick: PropTypes.func,
  onNextClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  isNextButtonDisabled: PropTypes.bool,
  disableButtons: PropTypes.bool,
};

StepProgressFooter.defaultProps = {
  steps: [],
  previousButtonLabel: null,
  nextButtonLabel: null,
  onPreviousClick: null,
  onNextClick: null,
  onCancelClick: null,
  isNextButtonDisabled: false,
  disableButtons: false,
};
